module.exports = __webpack_public_path__ + "img/ag2.ee687e0e.png";